import styled from "styled-components";

export const StyledReconnecting = styled.div`
  position: fixed;
  inset: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  h3 {
    color: var(--color-white);
    font-size: var(--font-size-xl);
    font-weight: 600;
    padding-top: var(--spacing-md)
  }
  p {
    color: var(--color-white);
    font-size: var(--font-size-lg);
    padding-bottom: var(--spacing-md);
  }
`;
